import { Button, Fade, Typography } from "@mui/material";

import { FileCopy, Link } from "@mui/icons-material";
import { useCallback, useState } from "react";

interface Props
{
    value: string
    iconClassName?: string
    label?: string
}
export default function CopyClipboardButton({ value, iconClassName, label }: Props)
{
    const [copiedRecently, setCopiedRecently] = useState(false);

    const copyToClipboard = useCallback(() =>
    {
        navigator.clipboard.writeText(value);
        setCopiedRecently(true);
        setTimeout(() =>
        {
            setCopiedRecently(false);
        }, 300);
    }, [value]);

    return <Button className={iconClassName} size={"small"} onClick={copyToClipboard}>
        <Fade style={{ position: "absolute", left: 4 }} in={copiedRecently}><FileCopy /></Fade>
        <Fade in={!copiedRecently}><Link /></Fade>
        <Typography variant="button">{label}</Typography>
    </Button>
}